export const filterOperations = {
    "NUMBER": [
        {
            code: "EQ",
            id: "equal",
        },
        {
            code: "NEQ",
            id: "notEqual"
        },
        {
            code: "GT",
            id: "greaterThan"
        },
        {
            code: "LT",
            id: "lessThan"
        },
        {
            code: "GTE",
            id: "greaterThanOrEqual"
        },
        {
            code: "LTE",
            id: "lessThanOrEqual"
        }
    ],
    "BOOLEAN": [
        {
            code: "EQ",
            id: "equal"
        },
        {
            code: "NEQ",
            id: "notEqual"
        }
    ],
    "STRING": [
        {
            code: "LIKE",
            id: "like"
        },
        {
            code: "LIKE_IC",
            id: "likeIgnoreCase"
        },
        {
            code: "NOT_LIKE",
            id: "notLike"
        },
        {
            code: "NOT_LIKE_IC",
            id: "notLikeIgnoreCase"
        }
    ],
    "TIMESTAMP": [
        {code: "BETWEEN", id: "BETWEEN"},
        {code: "BEFORE", id: "BEFORE"},
        {code: "EXACT_OR_BEFORE", id: "EXACT_OR_BEFORE"},
        {code: "AFTER", id: "AFTER"},
        {code: "EXACT_OR_AFTER", id: "EXACT_OR_AFTER"},
        {code: "EXACT", id: "EXACT"},
    ],
    "KEYWORD": [
        {code: "YESTERDAY", id: "YESTERDAY"},
        {code: "LAST_WEEK", id: "LAST_WEEK"},
        {code: "LAST_MONTH", id: "LAST_MONTH"},
    ],
    "EPOCH_NUMBER": [
        {
            code: "EQ",
            id: "equal"
        },
        {
            code: "NEQ",
            id: "notEqual"
        },
        {
            code: "GT",
            id: "greaterThan"
        },
        {
            code: "LT",
            id: "lessThan"
        },
        {
            code: "GTE",
            id: "greaterThanOrEqual"
        },
        {
            code: "LTE",
            id: "lessThanOrEqual"
        }
    ],
}
